import { render, staticRenderFns } from "./c_home_seckill.vue?vue&type=template&id=2c4407e3&scoped=true&"
import script from "./c_home_seckill.vue?vue&type=script&lang=js&"
export * from "./c_home_seckill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4407e3",
  null
  
)

export default component.exports